import { themeGet } from "@styled-system/theme-get";
import styled, { css } from "styled-components";
import { Button } from "orcs-design-system";

export const MasonryStyled = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: ${themeGet("space.r")};

  > div {
    outline: none;
  }
`;

export const DeleteButton = styled(Button)`
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  &:hover {
    background: rgba(0, 0, 0, 0.9);
    border: none;
  }
`;

export const MasonryCardButton = styled.div`
  height: 100%;
  width: 100%;
`;

export const MasonryCardContainer = styled.div`
  position: relative;
  display: block;
  width: ${({ width, avatarMode }) => (avatarMode ? "auto" : `${width}px`)};
  height: ${({ height, avatarMode }) => (avatarMode ? "auto" : `${height}px`)};
  border: none;
  border-radius: ${themeGet("radii.2")};
  overflow: hidden;
  cursor: pointer;
  background: ${({ color, avatarMode }) =>
    avatarMode ? "transparent" : color || "#f0f0f0"};
  transition: ${themeGet("transition.transitionDefault")};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0;

  img {
    transition: ${themeGet("transition.transitionDefault")};
  }
  ${({ isMultiSelect, hasSelectedImages }) =>
    isMultiSelect &&
    hasSelectedImages &&
    css`
      opacity: 0.6;
    `}

  ${({ isSelected, isSelectable }) =>
    isSelected
      ? css`
          opacity: 1;
          border: 3px solid ${themeGet("colors.success")};
          img {
            transform: scale(1.1);
          }
        `
      : isSelectable &&
        css`
          opacity: 0.9;
          border-color: ${themeGet("colors.white")};

          ${({ isUploading }) =>
            !isUploading &&
            css`
              &:hover {
                box-shadow: 0 2px 6px 0px rgba(0, 0, 0, 0.3);
                opacity: 1;
                outline: 1px solid ${themeGet("colors.black")};
                img {
                  transform: scale(1.1);
                }
              }
            `}
        `}

          ${({ isDeleting }) =>
    isDeleting &&
    css`
      opacity: 0.3 !important;
    `}

  ${({ isUploading }) =>
    isUploading &&
    css`
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
      }
    `}
`;

export const MasonryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const MasonryBackground = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  background: ${({ color }) => color};
`;

export const MasonryLabel = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  width: 100%;
  background: ${themeGet("colors.black50")};
  color: ${themeGet("colors.white")};
  font-size: ${themeGet("fontSizes.0")};
  font-weight: ${themeGet("fontWeights.2")};
  padding: ${themeGet("space.2")} ${themeGet("space.1")};
`;

export const MasonryAuthor = styled.a`
  color: white;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;
